/**
 * Boards selectors
 */

import { RootState } from "types";

import { createSelector } from "@reduxjs/toolkit";
import { initialFiltersValues, initialState } from "./initialState";

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state?.boardSetting || initialState;

export const selectIsBoardLoading = createSelector(
  [selectDomain],
  (state) => state.isBoardLoading,
);
export const selectIsBoardCreate = createSelector(
  [selectDomain],
  (state) => state.isBoardCreate,
);
export const selectBoardForm = createSelector(
  [selectDomain],
  (state) => state.boardForm,
);
export const selectDraftBoardForm = createSelector(
  [selectDomain],
  (state) => state.draftBoardForm,
);
export const selectIsBoardUpdate = createSelector(
  [selectDomain],
  (state) => state.isBoardUpdate,
);
export const selectTicketDropdownSearchKeyword = createSelector(
  [selectDomain],
  (state) => state.ticketDropdownSearchKeyword,
);

export const selectIsShownBoardSetting = createSelector(
  [selectDomain],
  (state) => state.isShownBoardSetting,
);
export const selectIsExportingBoard = createSelector(
  [selectDomain],
  (state) => state.isExportingBoard,
);
export const selectExportSettings = createSelector(
  [selectDomain],
  (state) => state.exportSettings,
);
export const selectBoardDraftFormModal = createSelector(
  [selectDomain],
  (state) => state.boardDraftFormModal,
);

export const selectBoardsShorting = createSelector(
  [selectDomain],
  (state) => state.boardsShorting,
);

export const selectDraftBoardFilters = createSelector(
  [selectDraftBoardForm],
  (draftBoardForm) => draftBoardForm.filters ?? initialFiltersValues,
);

export const selectBoardFilters = createSelector(
  [selectBoardForm],
  (boardForm) => boardForm.filters ?? initialFiltersValues,
);

